import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TopActionBar from "./TopActionBar";
import { SocketState } from "../context/SocketProvider";
import { AuthState } from "../context/AuthProvider";
import { SET_MAIN_LOADER } from "../redux/loaderSlice";
import { SHOW_MAIN_ERROR_MODAL } from "../redux/errorMessageSlice";
import { SHOW_MAIN_SUCCESS_MODAL } from "../redux/successMessageSlice";

import { Select1dUserWallet } from '../redux/1d-slice/gameInfo1dSlice.js'

const LayoutBalanceTransfer = () => {

    const dispatch = useDispatch();
    const { socket } = SocketState();
    const { userDetail } = AuthState();

    const [userList, setUserList] = useState([]);
    const [selectedUser, setSelectedUser] = useState("");
    const [amount, setAmount] = useState("");

    let userWallet = useSelector(Select1dUserWallet)

    /* ================= MY BALANCE ================= */
    const getMyBalance = () => {
        return userWallet;
    };

    /* ================= SELECTED USER BALANCE ================= */
    const getSelectedUserBalance = () => {
        const user = userList.find((u) => u._id === selectedUser);
        if (!user) return 0;

        return (user.chips || 0) + (user.game_winning || 0);
    };

    /* ================= USER LIST ================= */
    useEffect(() => {
        if (!socket) return;

        socket.emit("req", { en: "USER_LISTS", data: {} });

    }, [socket]);

    /* ================= SOCKET RESPONSE ================= */
    useEffect(() => {

        if (!socket) return;

        const handleRes = (res) => {
            switch (res.en) {
                case "USER_LISTS":
                    if (!res.err) {
                        setUserList(res.data?.lists || []);
                    }
                    break;

                case "USER_WALLET_UPDATE":
                    
                    dispatch(SET_MAIN_LOADER(false));

                    if (!res.err) {

                        dispatch(SHOW_MAIN_SUCCESS_MODAL(res.msg || "Wallet Updated"));

                        setAmount("");
                        setSelectedUser("");

                        socket.emit("req", { en: "USER_LISTS", data: {} });

                    } else {

                        dispatch(SHOW_MAIN_ERROR_MODAL(res.msg));

                    }

                    break;

                default:
                    break;
            }

        };

        socket.on("res", handleRes);

        return () => socket.off("res", handleRes);

    }, [socket, dispatch]);

    /* ================= ADD ================= */
    const handleAdd = () => {

        if (!selectedUser || !amount) {
            dispatch(SHOW_MAIN_ERROR_MODAL("Select user & enter amount"));
            return;
        }

        const myBalance = getMyBalance();

        if (Number(amount) > myBalance) {
            dispatch(SHOW_MAIN_ERROR_MODAL("Insufficient balance"));
            return;
        }

        dispatch(SET_MAIN_LOADER(true));

        socket.emit("req", {
            en: "USER_WALLET_UPDATE",
            data: {
                user_id: selectedUser,
                amount: Number(amount),
            },
        });

    };

    /* ================= DEDUCT ================= */
    const handleDeduct = () => {

        if (!selectedUser || !amount) {
            dispatch(SHOW_MAIN_ERROR_MODAL("Select user & enter amount"));
            return;
        }

        const userBalance = getSelectedUserBalance();

        if (Number(amount) > userBalance) {
            dispatch(SHOW_MAIN_ERROR_MODAL("User has insufficient balance"));
            return;
        }

        dispatch(SET_MAIN_LOADER(true));

        socket.emit("req", {
            en: "USER_WALLET_UPDATE",
            data: {
                user_id: selectedUser,
                amount: -Math.abs(Number(amount)),
            },
        });

    };

    return (
        <>
            <TopActionBar />

            <div className="main-container">

                {/* LEFT PANEL */}

                <div className="left-panel">

                    <h3>Wallet Update</h3>

                    {/* USER SELECT */}

                    <select
                        value={selectedUser}
                        onChange={(e) => setSelectedUser(e.target.value)}
                    >

                        <option value="">-- Select User --</option>

                        {userList.map((u) => (
                            <option key={u._id} value={u._id}>
                                {u.display_user_name} ({u.user_name})
                            </option>
                        ))}

                    </select>

                    <p style={{ fontWeight: "bold" }}>
                        My Balance: ₹ {getMyBalance()}
                    </p>

                    <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                        Selected User Balance: ₹ {getSelectedUserBalance()}
                    </p>

                    {/* AMOUNT */}

                    <input
                        type="number"
                        placeholder="Enter Amount"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                    />

                    {/* BUTTONS */}

                    <div className="btn-row">
                        <button className="btn-add" onClick={handleAdd}>
                            ADD
                        </button>
                        <button className="btn-deduct" onClick={handleDeduct}>
                            DEDUCT
                        </button>
                    </div>

                </div>

                {/* RIGHT PANEL */}

                <div className="right-panel">

                    <table>

                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>User ID</th>
                                <th>Balance</th>
                            </tr>
                        </thead>

                        <tbody>

                            {userList.map((u, i) => (

                                <tr key={u._id}>
                                    <td>{i + 1}</td>
                                    <td>{u.display_user_name}</td>
                                    <td>{u.user_name}</td>
                                    <td>{(u.chips || 0) + (u.game_winning || 0)}</td>
                                </tr>

                            ))}

                        </tbody>

                    </table>

                </div>

            </div>

            {/* CSS */}

            <style>{`

                .main-container{
                    display:flex;
                    gap:10px;
                    padding:10px;
                }

                .left-panel{
                    flex:1;
                    background:#e3f2fd;
                    padding:15px;
                    border-radius:4px;
                }

                .left-panel select,
                .left-panel input{
                    width:100%;
                    padding:8px;
                    margin-bottom:8px;
                    border:1px solid #999;
                }

                .btn-row{
                    display:flex;
                    gap:10px;
                }

                .btn-add{
                    flex:1;
                    background:green;
                    color:#fff;
                    padding:8px;
                    border:none;
                    cursor:pointer;
                }

                .btn-deduct{
                    flex:1;
                    background:red;
                    color:#fff;
                    padding:8px;
                    border:none;
                    cursor:pointer;
                }

                .right-panel{
                    flex:1.5;
                    overflow-x:auto;
                }

                table{
                    width:100%;
                    border-collapse:collapse;
                    background:#fff;
                }

                th,td{
                    border:1px solid #ccc;
                    padding:6px;
                }

                th{
                    background:#eee;
                }

                @media(max-width:768px){

                    .main-container{
                        flex-direction:column;
                    }

                }

            `}</style>

        </>
    );

};

export default LayoutBalanceTransfer;